export default {
  helpCenterLayoutTitle: {
    id: 'hc_navigation_help_center',
    defaultMessage: 'Help Center',
  },
  helpCenterLateResponseRateBanner: {
    id: 'hc_banner_lrr',
    defaultMessage:
      'Our agents are busier than usual, so replies may take longer.',
  },
}
